import React from 'react';

export const TeamsContext = React.createContext({
  activePage: null,
  setActivePage: () => null,
});

export const TeamsContextProvider = TeamsContext.Provider;
